export default __webpack_public_path__ + "static/media/quality.756c91a6.png";